// ============================================
// SITE CONTENT CONFIGURATION
// Edit this file to update all website content
// ============================================

// Import placeholder images (used as fallback)
import { PLACEHOLDER_IMAGES } from './placeholders'

// ============================================
// IMAGES CONFIGURATION
// ============================================
// Option 1: Use placeholders (default - works immediately)
// Option 2: Import actual images from assets folder
//
// To use actual images:
// 1. Add your images to src/assets/images/
// 2. Uncomment the imports below
// 3. Replace PLACEHOLDER_IMAGES with the imported images
// ============================================

// Uncomment these imports when you have actual images:
// import logo from '../assets/images/logo.png'
// import background from '../assets/images/background.png'
// import graphic1 from '../assets/images/graphic-1.png'
// import graphic2 from '../assets/images/graphic-2.png'
// import graphic3 from '../assets/images/graphic-3.png'
// import aboutImage from '../assets/images/about.png'
// import impactImage from '../assets/images/ourimpact.png'
// import tritonhacksLogo from '../assets/images/tritonhacks-logo.png'
// import curriculumLogo from '../assets/images/curriculum-logo.png'
// import earlystartLogo from '../assets/images/earlystart-logo.png'
// import discordIcon from '../assets/images/discord.png'
// import instagramIcon from '../assets/images/instagram.png'
// import linkedinIcon from '../assets/images/linkedin.png'
// import emailIcon from '../assets/images/email.png'

// ============================================
// IMAGES
// ============================================
// Using placeholders by default - replace with actual imports above
export const IMAGES = PLACEHOLDER_IMAGES

// When you have actual images, use this instead:
// export const IMAGES = {
//   logo,
//   background,
//   graphic1,
//   graphic2,
//   graphic3,
//   about: aboutImage,
//   impact: impactImage,
//   tritonhacks: tritonhacksLogo,
//   curriculum: curriculumLogo,
//   earlystart: earlystartLogo,
//   discord: discordIcon,
//   instagram: instagramIcon,
//   linkedin: linkedinIcon,
//   email: emailIcon,
// }

// ============================================
// SITE INFO
// ============================================
export const SITE_INFO = {
    name: 'CS Foreach',
    tagline: 'CS Foreach at UCSD',
    description: 'Dedicated to making computer science a more ubiquitous field, CS foreach is a student organization at UC San Diego that strives to make access to CS opportunities and resources more equitable for each and every student.',
    email: 'csforeac@ucsd.edu',
    discordUrl: 'https://discord.gg/zQRdJJxh2m',
    copyright: '© 2026 by CS foreach',
}

// ============================================
// NAVIGATION LINKS
// ============================================
export const NAV_LINKS = [
    { label: 'HOME', href: '/' },
    { label: 'ABOUT', href: '/about' },
    { label: 'PROGRAMS', href: '/programs' },
    { label: 'TEAM', href: '/team' },
    { label: 'PARTNERS', href: '/partners' },
    { label: 'GET INVOLVED', href: '/get-involved' },
]

// ============================================
// HERO SECTION
// ============================================
export const HERO_CONTENT = {
    title: 'Striving for Equity and Access in Computer Science Education',
    description: 'Dedicated to making computer science a more ubiquitous field, CS foreach is a student organization at UC San Diego that strives to make access to CS opportunities and resources more equitable for each and every student.',
    primaryButton: {
        label: 'GET INVOLVED',
        href: '/get-involved',
    },
    secondaryButton: {
        label: 'SCHEDULE A WORKSHOP',
        href: '/partners',
    },
}

// ============================================
// ABOUT SECTION
// ============================================
export const ABOUT_CONTENT = {
    title: 'ABOUT US',
    description: 'CS foreach is a student-run organization at UC San Diego that aims to increase equity and access in computer science education through our various programs. We work with educators throughout San Diego to teach and mentor traditionally underserved K-12 students.',
    buttonLabel: 'LEARN MORE',
    buttonHref: '/about',
}

// ============================================
// PROGRAMS & HISTORICAL DATA
// ============================================
export const PROGRAMS = [
    {
        id: 'tritonhacks',
        logo: 'tritonhacks',
        title: 'TritonHacks',
        description: 'A beginner-friendly high school hackathon that includes project kits, workshops, and mentors.',
        href: '/programs#tritonhacks',
    },
    {
        id: 'curriculum',
        logo: 'curriculum',
        title: 'Curriculum',
        description: 'Runs CS workshops year-round to provide supplementary material to school curriculum.',
        href: '/programs#curriculum',
    },
    {
        id: 'earlystart',
        logo: 'earlystart',
        title: 'Early Start',
        description: '15-week program that matches high schoolers with UCSD students to work on a CS project.',
        href: '/programs#earlystart',
    },
]

export const TRITONHACKS_EVENTS = [
    {
        year: '2026',
        image: '/images/TritonHacksLogo.png',
        status: 'Coming Spring 2026'
    },
    {
        year: '2025',
        image: '/images/TritonHacks5.png',
        impactReport: 'https://github.com/tritonhacks/TH25-Impact-Report/blob/main/README.md',
        projectGallery: 'https://tritonhacks-2025.devpost.com/project-gallery'
    },
    {
        year: '2024',
        image: '/images/TritonHacks3.png',
        impactReport: 'https://github.com/tritonhacks/TH24-Impact-Report/blob/main/README.md',
        projectGallery: 'https://tritonhacks-2024.devpost.com/project-gallery?page=1'
    },
    {
        year: '2023',
        image: '/images/TritonHacks1.png',
        website: 'https://www.tritonhacks.org/',
        impactReport: 'https://github.com/tritonhacks/TH23-Impact-Report/blob/main/Tritonhacks-2023.md',
        projectGallery: 'https://tritonhacks23.devpost.com/project-gallery'
    }
]

export const EARLY_START_PROJECTS = [
    {
        title: 'COHORT PROJECT 1',
        image: '/images/EarlyStart1.png',
        url: 'https://theodorealoucsd.github.io/Team-CSforeachers/Pages/index.html'
    },
    {
        title: 'COHORT PROJECT 2',
        image: '/images/EarlyStart2.png',
        url: 'https://mohaelder.github.io/Project-Inspo/'
    }
]

export const PAST_WORKSHOPS = [
    {
        image: '/images/Curriculum1.png',
        title: "Turtlin': Implementing Lindenmayer Systems with Clean Code",
        subject: 'Python'
    },
    {
        image: '/images/Curriculum2.png',
        title: 'Inheritance & Recursion',
        subject: 'AP CS, Java'
    },
    {
        image: '/images/Curriculum3.png',
        title: 'CS foreach x IEEE: 3D Printing',
        subject: 'Industry Skills'
    }
]

// ============================================
// TEAM MEMBERS
// ============================================
export const TEAM_MEMBERS = [
    { name: 'Nicole', role: 'President', image: 'https://via.placeholder.com/150/4A90E2/FFFFFF?text=Nicole' },
    { name: 'Nehal', role: 'Curriculum Director & Co-VP', image: 'https://via.placeholder.com/150/4A90E2/FFFFFF?text=Nehal' },
    { name: 'Shawn', role: 'Finance Director & Co-VP', image: 'https://via.placeholder.com/150/4A90E2/FFFFFF?text=Shawn' },
    { name: 'Allie', role: 'Co-Director of TritonHacks', image: 'https://via.placeholder.com/150/4A90E2/FFFFFF?text=Allie' },
    { name: 'Parth', role: 'Co-Director of TritonHacks', image: 'https://via.placeholder.com/150/4A90E2/FFFFFF?text=Parth' },
    { name: 'Himanth', role: 'Head of Events', image: 'https://via.placeholder.com/150/4A90E2/FFFFFF?text=Himanth' },
    { name: 'Dylan', role: 'Director of Web Operations', image: 'https://via.placeholder.com/150/4A90E2/FFFFFF?text=Dylan' },
    { name: 'Prakhar', role: 'Director of Web Operations', image: 'https://via.placeholder.com/150/4A90E2/FFFFFF?text=Prakhar' },
]

// ============================================
// IMPACT STATS
// ============================================
export const IMPACT_CONTENT = {
    title: 'OUR IMPACT',
    description: "Through our efforts, we've been able to build up our organization and create meaningful computer science opportunities for students in our community.",
    period: 'During the 2024 - 2025 school year...',
    stats: [
        { number: '50', label: 'active organization members' },
        { number: '7', label: 'schools we work with in San Diego' },
        { number: '25', label: 'workshops provided (and counting!)' },
    ],
}

// ============================================
// INVOLVEMENT & CONTACT
// ============================================
export const INVOLVEMENT_CONTENT = {
    faq: [
        {
            q: 'What age groups do you serve?',
            a: 'We primarily work with K-12 students in the San Diego area, with a focus on traditionally underserved communities.'
        },
        {
            q: 'Do I need prior coding experience?',
            a: 'No! We have programs for complete beginners as well as more advanced students. We\'ll help you find the right starting point.'
        },
        {
            q: 'How do I sign up for a program?',
            a: 'Fill out the contact form below or email us directly at csforeac@ucsd.edu with your interest!'
        },
        {
            q: 'Can my school partner with CS foreach?',
            a: 'Absolutely! We love working with schools. Contact us to discuss how we can support your CS education goals.'
        }
    ],
    contactFormUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSdaUmKA9Rj2TeMGC_fLW9VGvE0905eqUG3jw56WmRxxZT1Xdg/viewform'
}

// ============================================
// SOCIAL LINKS
// ============================================
export const SOCIAL_LINKS = [
    {
        id: 'discord',
        icon: 'discord',
        href: 'https://discord.gg/zQRdJJxh2m', // Updated
        label: 'Discord'
    },
    {
        id: 'instagram',
        icon: 'instagram',
        href: 'https://www.instagram.com/csforeach/',
        label: 'Instagram'
    },
    {
        id: 'linkedin',
        icon: 'linkedin',
        href: 'https://www.linkedin.com/company/csforeach/',
        label: 'LinkedIn'
    },
    {
        id: 'email',
        icon: 'email',
        href: 'mailto:csforeac@ucsd.edu',
        label: 'Email'
    },
]

// ============================================
// EVENTS (For Calendar)
// ============================================
export const EVENTS = [
    {
        date: '2026-02-18',
        title: 'Patrick Henry HS Event',
        time: '11:00 AM - 12:00 PM',
        description: 'Join us for a CS workshop event at Patrick Henry High School!',
        location: 'CSE Fishbowl'
    },
    {
        date: '2026-03-04',
        title: 'Study Jam & Boba',
        time: 'TBD',
        description: 'Come study with us and enjoy some boba at Price Center!',
        location: 'Price Center'
    }
]
